export const PATTERNS = {
  specialCharacters: /[[!@#$%^&*()_+=\-[\]{};':"|,.<>/?]/,
  numbers: /\d/,
  mayus: /[A-Z]/,
  minus: /[a-z]/,
  passwords: /^(?=.*\d)(?=.*[a-z])(?=.*[[!@#$%^&*()_+=\-[\]{};':"|,.<>/?])(?=.*[A-Z]).{8,40}$/,
  email: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
};
